const TLPAppConfig = [
    {
      headline: 'Bedarfs- und Kapazitätsmanagement',
      subcategories: [
        { name: '14-Tage-Forecasts', outlined: false, url: '' },
        { name: '16-Wochen-Forecasts', outlined: false, url: '' },
        { name: '12-Monate-Forecasts', outlined: false, url: '' },
        { name: 'Alle Forecasts', outlined: true, url: '' },
      ],
    },
    {
      headline: 'Bedarfs- und Kapazitätsberechnung',
      subcategories: [
        { name: '14-Tage-Forecasts', outlined: false, url: '' },
        { name: '16-Wochen-Forecasts', outlined: false, url: '' },
        { name: '12-Monate-Forecasts', outlined: false, url: '' },
        { name: 'Alle Forecasts', outlined: true, url: '' },
        { name: 'DL Quote', outlined: false, url: '' },
        { name: 'Routenquote', outlined: false, url: '' },
        { name: 'FC Input Daten', outlined: true, url: '' },
      ],
    },
    {
      headline: 'Forecast Analytics',
      subcategories: [
        { name: '14-Tage-Forecasts', outlined: false, url: '' },
        { name: '16-Wochen-Forecasts', outlined: false, url: '' },
        { name: '12-Monate-Forecasts', outlined: false, url: '' },
        { name: 'Forecast Abgleich', outlined: true, url: '' },
      ],
    },
    {
      headline: 'Texte und Kommunikation',
      subcategories: [
        { name: 'Texte', outlined: false, url: '' },
        { name: 'Mail Kommunikation', outlined: false, url: '' },
      ],
    },
    {
      headline: 'Schiff Bericht',
      subcategories: [
        { name: 'Schiffskapazitäten', outlined: false, url: '' },
      ],
    },
    {
      headline: 'Stammdaten',
      subcategories: [
        { name: 'Lieferanten', outlined: false, url: '' },
        { name: 'Firmengruppen', outlined: false, url: '' },
        { name: 'Werke', outlined: false, url: '' },
        { name: 'Vertragsvolumen', outlined: false, url: '' },
        { name: 'Gruppenverwaltung', outlined: false, url: '' },
      ],
    },
  ];
  
  export default TLPAppConfig;
  